import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'order-editing-form-refund-handling',
  standalone: false,
  templateUrl: './order-editing-form-refund-handling.component.html',
  styleUrl: './order-editing-form-refund-handling.component.scss',
})
export class OrderEditingFormRefundHandlingComponent {
  @Input({ required: true }) refundHandlingTypeControl: FormControl<OrderEditing.RefundHandlingType>;
  @Input({ required: true }) automaticRefundOptionText: string;

  RefundHandlingType = OrderEditing.RefundHandlingType;

  constructor(public orderEditingService: OrderEditingService) {}
}
